import { Box, Divider, DragDrop, Grid2, Show, Typography } from "components";
import { useState } from "react";
import { Controller, useFormContext } from "react-hook-form";

const UploadPlanProofs = () => {
  const form = useFormContext();

  const [uploadError, setUploadError] = useState(null);

  const aumBasedPlanWatch = form.watch("planDataObject.aumBasedPlan");

  return (
    <Grid2 container spacing={2}>
      <Grid2 size={8} display={"flex"} flexDirection={"column"} gap={1}>
        <Typography
          fontSize={20}
          fontWeight={600}
          // pt={2}
          sx={{ fontSize: "clamp(1.125rem, 0.6563rem + 1.5vw, 1.5rem)" }}
        >
          Verify your investments for compliance purposes
        </Typography>
      </Grid2>
      <Grid2
        size={4}
        display={"flex"}
        justifyContent={"flex-end"}
        alignItems={"start"}
      >
        <img
          src="/Logos/iconFullLogo.png"
          alt="GridKey Logo"
          style={{
            height: "32px",
            width: "auto",
          }}
        />
      </Grid2>
      <Show.When
        isTrue={
          aumBasedPlanWatch === "withHoldings" || aumBasedPlanWatch === "both"
        }
      >
        <Grid2 size={12} display={"flex"} flexDirection={"column"} gap={1}>
          <Typography fontSize={12} fontWeight={500} color="var(--neutral-500)">
            Upload proof of your holding value (Demat holding Statement)
          </Typography>
          <Controller
            control={form.control}
            name="planDataObject.cashProofs"
            render={({ field }) => {
              return (
                <Box>
                  <DragDrop
                    {...field}
                    supportName=".xlsx, .pdf"
                    acceptType={".xlsx,.pdf"}
                    multiple
                    onChange={(e) => field.onChange(e)}
                    setUploadError={setUploadError}
                    uploadError={uploadError}
                  />
                </Box>
              );
            }}
          />
        </Grid2>
      </Show.When>

      <Show.When isTrue={aumBasedPlanWatch === "both"}>
        <Grid2 size={12} mt={2} mb={2}>
          <Divider />
        </Grid2>
      </Show.When>

      <Show.When
        isTrue={
          aumBasedPlanWatch === "withCash" || aumBasedPlanWatch === "both"
        }
      >
        <Grid2 size={12} gap={1} display={"flex"} flexDirection={"column"}>
          <Typography fontSize={12} fontWeight={500} color="var(--neutral-500)">
            Upload proof of your bank balance (Latest bank statement)
          </Typography>
          <Controller
            control={form.control}
            name="planDataObject.holdingsProofs"
            render={({ field }) => {
              return (
                <DragDrop
                  {...field}
                  supportName=".xlsx, .pdf"
                  acceptType={".xlsx,.pdf"}
                  multiple
                  onChange={(e) => field.onChange(e)}
                  setUploadError={setUploadError}
                  uploadError={uploadError}
                />
              );
            }}
          />
        </Grid2>
      </Show.When>
    </Grid2>
  );
};

export default UploadPlanProofs;
